/**
 * Loads tracking scripts (e.g. Facebook Pixel) based on the current subdomain.
 * Supports both production domains (e.g. tokyotrek.example.com) and localhost subdomains (e.g. tokyotrek.localhost).
 * 
 * @param {Object} subdomainTrackingConfig - Configuration object from config.SUBDOMAIN_TRACKING
 */
export function loadScriptsForCurrentSubdomain(subdomainTrackingConfig) {
  if (typeof window === 'undefined') {
    return;
  }

  // Don't load tracking scripts when offline
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return;
  }

  const host = window.location.hostname || '';
  const parts = host.split('.');
  const subdomainTracking = subdomainTrackingConfig || {};
  
  // Determine which pixel to use
  let pixelId = null;
  
  // Check if there's a subdomain
  // Production: tokyotrek.example.com → parts = ['tokyotrek', 'example', 'com'] → length 3
  // Localhost: tokyotrek.localhost → parts = ['tokyotrek', 'localhost'] → length 2
  // Localhost with port: tokyotrek.localhost:1024 → hostname is 'tokyotrek.localhost' (port removed)
  let subdomain = null;
  
  if (parts.length >= 3) {
    // Production domain with subdomain (e.g. tokyotrek.example.com)
    subdomain = parts[0].toLowerCase();
  } else if (parts.length >= 2 && (parts[1] === 'localhost' || parts[1] === 'local')) {
    // Localhost subdomain (e.g. tokyotrek.localhost or tokyotrek.local)
    subdomain = parts[0].toLowerCase();
  }
  
  // If we found a subdomain, check for its config
  if (subdomain) {
    const subdomainConfig = subdomainTracking[subdomain];
    
    // If subdomain has its own pixel config, use it
    if (subdomainConfig && subdomainConfig.facebookPixelId) {
      pixelId = subdomainConfig.facebookPixelId;
    }
  }
  
  // If no subdomain-specific pixel found, use default
  if (!pixelId) {
    const defaultConfig = subdomainTracking.default;
    if (defaultConfig && defaultConfig.facebookPixelId) {
      pixelId = defaultConfig.facebookPixelId;
    }
  }

  // Load Facebook Pixel if we have a pixel ID
  if (pixelId) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script');

    // Wait for fbq to be available (it's loaded asynchronously)
    let retryCount = 0;
    const maxRetries = 50; // 5 seconds max wait time
    const initFacebookPixel = () => {
      if (typeof window.fbq === 'function') {
        window.fbq('init', pixelId);
        window.fbq('track', 'PageView');
      } else {
        retryCount++;
        if (retryCount < maxRetries) {
          setTimeout(initFacebookPixel, 100);
        }
      }
    };
    initFacebookPixel();
  }
}

